import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { BsCaretLeftFill } from '@react-icons/all-files/bs/BsCaretLeftFill';
import { BsCaretRightFill } from '@react-icons/all-files/bs/BsCaretRightFill';

export interface ISidebarProps {
    readonly children?: React.ReactNode;
    readonly title: React.ReactNode;
    readonly visible: boolean;
    readonly className?: string;
    readonly footer?: React.ReactNode;
    readonly links?: React.ReactNode;
    readonly isMedium?: boolean;
    readonly collapseSidebar: any;
    readonly sidebarCollapsed: boolean;
}

@observer
export class Sidebar extends React.Component<ISidebarProps> {
    public render() {
        return (
            <aside id="sidebar" className={this.asideClassName + ' ' + this.props.className}>
                <div className="sidebar-header flex-items-center h100">{this.props.title}</div>

                <div className="sidebar-content">
                    <nav className="sidebar-nav pt-0">
                        {this.props.links}
                        {this.sidebarToggleButton}
                    </nav>
                    {this.props.footer}
                </div>

                {this.props.children}
            </aside>
        );
    }

    @computed
    private get asideClassName() {
        let className = 'sidebar-container';

        if (!this.props.visible) {
            className += ' d-none d-lg-block';
        }

        return className;
    }

    @computed
    get sidebarToggleButton() {
        return (
            <ul className="p-0">
                <LinkContainer
                    to="#"
                    onClick={this.props.collapseSidebar}
                    className={this.props.sidebarCollapsed ? 'w-100 text-center' : 'float-end'}
                >
                    <div>
                        <a className="sidebar-toggle p-3 w-100">
                            {this.props.sidebarCollapsed ? (
                                <BsCaretRightFill className="m-0" />
                            ) : (
                                <BsCaretLeftFill className="m-0" />
                            )}
                        </a>
                    </div>
                </LinkContainer>
            </ul>
        );
    }
}
